import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledSwitchDialog from 'components/organisms/Dialogs/SwitchDialog/SwitchDialog.styles';
import ActionButton from 'components/molecules/Buttons/ActionButton/ActionButton';
import DialogContent from 'components/atoms/Dialogs/DialogContent/DialogContent';
import DialogHeader from 'components/molecules/Dialogs/DialogHeader/DialogHeader';
import DialogFooter from 'components/molecules/Dialogs/DialogFooter/DialogFooter';

const SwitchDialog = React.forwardRef((props, ref) => {
  const {
    title,
    form,
    info,
    buttonActions,
    ActionButtonProps,
    ...innerProps
  } = useComponentProps(props, 'SwitchDialog', {
    children: ['title', 'content', 'actions'],
  });

  const renderButtons = () => {
    return buttonActions?.map((action, idx) => {
      return <ActionButton key={idx}
                           action={action}
                           color="primary"
                           {...ActionButtonProps}/>
    })
  }

  return <StyledSwitchDialog ref={ref} {...innerProps}>
    <DialogHeader className="SwitchDialog-header"
                  title={title} />
    <DialogContent className="SwitchDialog-content">
      {form}
    </DialogContent>
    {(buttonActions?.length > 0 || info) ?
      <DialogFooter className="SwitchDialog-footer"
                    info={info}
                    buttons={renderButtons()} /> : null}
  </StyledSwitchDialog>
});

SwitchDialog.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  title: PropTypes.string,
  form: PropTypes.element,
  buttonActions: PropTypes.array,
  ActionButtonProps: PropTypes.object
};

export default SwitchDialog;
